const initializedInputs = new WeakSet();

const readStoredOrderId = key => {
    try {
        return localStorage.getItem(key) ?? '';
    } catch {
        return '';
    }
};

const storeOrderId = (key, value) => {
    try {
        if (value === '') {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }
    } catch {
    }
};

export const initializeSampleOrderStorage = scope => {
    scope.querySelectorAll('input[data-sample-order-storage]').forEach(input => {
        if (initializedInputs.has(input)) {
            return;
        }

        initializedInputs.add(input);

        const key            = input.dataset.sampleOrderStorage;
        const templateEditor = input.closest('.template-editor');

        if (templateEditor) {
            templateEditor.addEventListener('template:orderState', event => {
                const detail  = event.detail ?? {};
                const orderId = (detail.orderId ?? '').toString().trim();

                storeOrderId(key, detail.state === 'valid' ? orderId : '');
            });
        }

        const stored = readStoredOrderId(key);

        if (stored === '' || input.value !== '' || !templateEditor) {
            return;
        }

        input.value = stored;

        const target = templateEditor.querySelector(templateEditor.getAttribute('hx-target'));

        if (target) {
            target.classList.add('template-preview-restoring');
            templateEditor.addEventListener(
                'htmx:afterSwap',
                () => target.classList.remove('template-preview-restoring'),
                {once: true},
            );
        }

        templateEditor.dispatchEvent(new Event('preview:run'));
    });
};
